import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "../../styles/crearEmpresaPopup.module.css";
import { useTranslation } from "react-i18next";

const EditarEquipoPopup = ({ onClose, onUpdate, currentName }) => {
  const [nombre, setNombre] = useState(currentName || "");
  const [error, setError] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    setNombre(currentName || "");
    setError("");
  }, [currentName]);

  const handleChange = (e) => {
    setNombre(e.target.value);
    if (error) setError("");
  };

  const handleSubmit = async () => {
    const nombreTrim = typeof nombre === "string" ? nombre.trim() : "";
    if (!nombreTrim) {
      setError(t("teamNameEmpty") || "El nombre del equipo no puede estar vacío");
      return;
    }
    setError("");
    try {
      await onUpdate(nombreTrim);
      onClose();
    } catch (err) {
      setError(err?.message || t("errorUpdatingTeam") || "Error al actualizar el equipo");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className={styles.popupOverlay} onClick={handleClickOutside}>
      <div className={styles.popupContent}>
        <h2>{t("editTeam") || "Editar equipo"}</h2>
        <label className={styles.label}>
          {t("teamName") || "Nombre del equipo"}
          <input
            type="text"
            value={nombre}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className={`${styles.input} ${error ? styles.inputError : ""}`}
            placeholder={t("teamName") || "Nombre del equipo"}
            autoFocus
          />
        </label>
        {error && <span className={styles.error}>{error}</span>}
        <div className={styles.popupActions}>
          <button onClick={onClose} className={styles.buttonCancel}>
            {t("cancel")}
          </button>
          <button onClick={handleSubmit} className={styles.buttonUpdate}>
            {t("save")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EditarEquipoPopup;
